function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { pick, values } from 'ramda';
import { ApiConstants, ThunkHelper } from 'invision-core';
import { buildCustomerRequestObject as buildSubscriberObject } from '../helpers/customer.helper';
export var RETRIEVE_HIERARCHY_CONSTANTS = {
  BEGIN: 'RETRIEVE_HIERARCHY_BEGIN',
  SUCCESS: 'RETRIEVE_HIERARCHY_SUCCESS',
  FAILURE: 'RETRIEVE_HIERARCHY_FAILURE'
};
var RETRIEVE_HIERARCHY_EVENTS = [RETRIEVE_HIERARCHY_CONSTANTS.BEGIN, RETRIEVE_HIERARCHY_CONSTANTS.SUCCESS, RETRIEVE_HIERARCHY_CONSTANTS.FAILURE];
var retrieveHierarchyPromise = function retrieveHierarchyPromise(dispatch, hierarchyId) {
  return ThunkHelper(dispatch, RETRIEVE_HIERARCHY_EVENTS, {
    method: 'post',
    url: 'SubscriberManagement/RetrieveHierarchy',
    data: {
      HierarchyId: hierarchyId
    }
  });
};
export var retrieveHierarchy = function retrieveHierarchy(hierarchyId) {
  return function (dispatch) {
    return retrieveHierarchyPromise(dispatch, hierarchyId);
  };
};
export var SET_SELECTED_HIERARCHY_NODE = 'SET_SELECTED_HIERARCHY_NODE';
export var setSelectedHierarchyNode = function setSelectedHierarchyNode(hierarchyNodeId) {
  return {
    type: SET_SELECTED_HIERARCHY_NODE,
    payload: hierarchyNodeId
  };
};
export var SET_POPUP_HIERARCHY_NODE = 'SET_POPUP_HIERARCHY_NODE';
export var setPopupHierarchyNode = function setPopupHierarchyNode(popupNode) {
  return {
    type: SET_POPUP_HIERARCHY_NODE,
    payload: popupNode
  };
};
export var UPDATE_HIERARCHY_NODE_CONSTANTS = {
  BEGIN: 'UPDATE_HIERARCHY_NODE_BEGIN',
  SUCCESS: 'UPDATE_HIERARCHY_NODE_SUCCESS',
  FAILURE: 'UPDATE_HIERARCHY_NODE_FAILURE'
};
export var UPDATE_HIERARCHY_NODE_EVENTS = [UPDATE_HIERARCHY_NODE_CONSTANTS.BEGIN, UPDATE_HIERARCHY_NODE_CONSTANTS.SUCCESS, UPDATE_HIERARCHY_NODE_CONSTANTS.FAILURE];
var updateHierarchyNodePromise = function updateHierarchyNodePromise(dispatch, request, customerId) {
  return ThunkHelper(dispatch, UPDATE_HIERARCHY_NODE_EVENTS, {
    method: 'post',
    url: 'SubscriberManagement/UpdateHierarchyNode',
    data: request,
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, customerId)
  });
};
export var updateHierarchyNode = function updateHierarchyNode(request, customerId) {
  return function (dispatch) {
    return updateHierarchyNodePromise(dispatch, request, customerId);
  };
};
export var RETRIEVE_NODE_CONVERGENT_BILLER_SUBSCRIBER_SUMMARY_CONSTANTS = {
  BEGIN: 'RETRIEVE_NODE_CONVERGENT_BILLER_SUBSCRIBER_SUMMARY_BEGIN',
  SUCCESS: 'RETRIEVE_NODE_CONVERGENT_BILLER_SUBSCRIBER_SUMMARY_SUCCESS',
  FAILURE: 'RETRIEVE_NODE_CONVERGENT_BILLER_SUBSCRIBER_SUMMARY_FAILURE'
};
var RETRIEVE_NODE_CONVERGENT_BILLER_SUBSCRIBER_SUMMARY_EVENTS = [RETRIEVE_NODE_CONVERGENT_BILLER_SUBSCRIBER_SUMMARY_CONSTANTS.BEGIN, RETRIEVE_NODE_CONVERGENT_BILLER_SUBSCRIBER_SUMMARY_CONSTANTS.SUCCESS, RETRIEVE_NODE_CONVERGENT_BILLER_SUBSCRIBER_SUMMARY_CONSTANTS.FAILURE];
export var retrieveNodeConvergentBillerSubscriberSummaryPromise = function retrieveNodeConvergentBillerSubscriberSummaryPromise(dispatch, customerId) {
  return ThunkHelper(dispatch, RETRIEVE_NODE_CONVERGENT_BILLER_SUBSCRIBER_SUMMARY_EVENTS, {
    method: 'post',
    url: 'SubscriberManagement/RetrieveConvergentBillerSubscriberSummary',
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, customerId)
  }, {
    customerId: customerId
  });
};
export var retrieveNodeConvergentBillerSubscriberSummary = function retrieveNodeConvergentBillerSubscriberSummary(customerId) {
  return function (dispatch) {
    return retrieveNodeConvergentBillerSubscriberSummaryPromise(dispatch, customerId);
  };
};
export var RETRIEVE_POPUP_NODE_CONVERGENT_BILLER_SUBSCRIBER_SUMMARY_CONSTANTS = {
  BEGIN: 'RETRIEVE_POPUP_NODE_CONVERGENT_BILLER_SUBSCRIBER_SUMMARY_BEGIN',
  SUCCESS: 'RETRIEVE_POPUP_NODE_CONVERGENT_BILLER_SUBSCRIBER_SUMMARY_SUCCESS',
  FAILURE: 'RETRIEVE_POPUP_NODE_CONVERGENT_BILLER_SUBSCRIBER_SUMMARY_FAILURE'
};
export var retrievePopupNodeConvergentBillerSubscriberSummaryPromise = function retrievePopupNodeConvergentBillerSubscriberSummaryPromise(dispatch, customerId) {
  return ThunkHelper(dispatch, values(RETRIEVE_POPUP_NODE_CONVERGENT_BILLER_SUBSCRIBER_SUMMARY_CONSTANTS), {
    method: 'post',
    url: 'SubscriberManagement/RetrieveConvergentBillerSubscriberSummary',
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, customerId)
  }, {
    customerId: customerId
  });
};
export var retrievePopupNodeConvergentBillerSubscriberSummary = function retrievePopupNodeConvergentBillerSubscriberSummary(customerId) {
  return function (dispatch) {
    return retrievePopupNodeConvergentBillerSubscriberSummaryPromise(dispatch, customerId);
  };
};
export var SEARCH_HIERARCHY_NODES_CONSTANTS = {
  BEGIN: 'SEARCH_HIERARCHY_NODES_CONSTANTS_BEGIN',
  SUCCESS: 'SEARCH_HIERARCHY_NODES_CONSTANTS_SUCCESS',
  FAILURE: 'SEARCH_HIERARCHY_NODES_CONSTANTS_FAILURE'
};
export var searchHierarchyNodesPromise = function searchHierarchyNodesPromise(dispatch, customerId, request) {
  return ThunkHelper(dispatch, values(SEARCH_HIERARCHY_NODES_CONSTANTS), {
    method: 'post',
    url: 'SubscriberManagement/SearchHierarchyNodes',
    data: request,
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, customerId)
  }, request);
};
export var searchHierarchyNodes = function searchHierarchyNodes(customerId, request) {
  return function (dispatch) {
    return searchHierarchyNodesPromise(dispatch, customerId, request);
  };
};
export var RETRIEVE_POPUP_NODE_CONVERGENT_BILLER_ACCOUNT_DETAILS_CONSTANTS = {
  BEGIN: 'RETRIEVE_POPUP_NODE_CONVERGENT_BILLER_ACCOUNT_DETAILS_BEGIN',
  SUCCESS: 'RETRIEVE_POPUP_NODE_CONVERGENT_BILLER_ACCOUNT_DETAILS_SUCCESS',
  FAILURE: 'RETRIEVE_POPUP_NODE_CONVERGENT_BILLER_ACCOUNT_DETAILS_FAILURE'
};
var RETRIEVE_POPUP_NODE_CONVERGENT_BILLER_ACCOUNT_DETAILS_EVENTS = [RETRIEVE_POPUP_NODE_CONVERGENT_BILLER_ACCOUNT_DETAILS_CONSTANTS.BEGIN, RETRIEVE_POPUP_NODE_CONVERGENT_BILLER_ACCOUNT_DETAILS_CONSTANTS.SUCCESS, RETRIEVE_POPUP_NODE_CONVERGENT_BILLER_ACCOUNT_DETAILS_CONSTANTS.FAILURE];
export var retrievePopupNodeConvergentBillerAccountDetailsPromise = function retrievePopupNodeConvergentBillerAccountDetailsPromise(dispatch, customerId) {
  return ThunkHelper(dispatch, RETRIEVE_POPUP_NODE_CONVERGENT_BILLER_ACCOUNT_DETAILS_EVENTS, {
    method: 'post',
    url: 'SubscriberManagement/RetrieveConvergentBillerAccountDetails',
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, customerId)
  });
};
export var retrievePopupNodeConvergentBillerAccountDetails = function retrievePopupNodeConvergentBillerAccountDetails(customerId) {
  return function (dispatch) {
    return retrievePopupNodeConvergentBillerAccountDetailsPromise(dispatch, customerId);
  };
};
export var UPDATE_NODE_SERVICE_CONSTANTS = {
  BEGIN: 'UPDATE_NODE_SERVICE_BEGIN',
  SUCCESS: 'UPDATE_NODE_SERVICE_SUCCESS',
  FAILURE: 'UPDATE_NODE_SERVICE_FAILURE'
};
export var UPDATE_NODE_SERVICE_EVENTS = [UPDATE_NODE_SERVICE_CONSTANTS.BEGIN, UPDATE_NODE_SERVICE_CONSTANTS.SUCCESS, UPDATE_NODE_SERVICE_CONSTANTS.FAILURE];
var updateNodeServicePromise = function updateNodeServicePromise(dispatch, request, destinationCustomerId) {
  return ThunkHelper(dispatch, UPDATE_NODE_SERVICE_EVENTS, {
    method: 'post',
    url: 'SubscriberManagement/UpdateChargeRedirectInstance',
    data: request,
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, destinationCustomerId)
  });
};
export var updateNodeService = function updateNodeService(request, destinationCustomerId) {
  return function (dispatch) {
    return updateNodeServicePromise(dispatch, request, destinationCustomerId);
  };
};
export var RETRIEVE_POPUP_NODE_REDIRECTED_SERVICES_CONSTANTS = {
  BEGIN: 'RETRIEVE_POPUP_NODE_REDIRECTED_SERVICES_BEGIN',
  SUCCESS: 'RETRIEVE_POPUP_NODE_REDIRECTED_SERVICES_SUCCESS',
  FAILURE: 'RETRIEVE_POPUP_NODE_REDIRECTED_SERVICES_FAILURE'
};
export var RETRIEVE_POPUP_NODE_SERVICES_EVENTS = [RETRIEVE_POPUP_NODE_REDIRECTED_SERVICES_CONSTANTS.BEGIN, RETRIEVE_POPUP_NODE_REDIRECTED_SERVICES_CONSTANTS.SUCCESS, RETRIEVE_POPUP_NODE_REDIRECTED_SERVICES_CONSTANTS.FAILURE];
var retrievePopupNodeRedirectedServicesPromise = function retrievePopupNodeRedirectedServicesPromise(dispatch, destinationCustomerId) {
  return ThunkHelper(dispatch, RETRIEVE_POPUP_NODE_SERVICES_EVENTS, {
    method: 'post',
    url: 'SubscriberManagement/RetrieveChargeRedirectInstances',
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, destinationCustomerId)
  });
};
export var retrievePopupNodeRedirectedServices = function retrievePopupNodeRedirectedServices(destinationCustomerId) {
  return function (dispatch) {
    return retrievePopupNodeRedirectedServicesPromise(dispatch, destinationCustomerId);
  };
};
export var CREATE_CHILD_CONSTANTS = {
  BEGIN: 'CREATE_CHILD_BEGIN',
  SUCCESS: 'CREATE_CHILD_SUCCESS',
  FAILURE: 'CREATE_CHILD_FAILURE'
};
var CREATE_CHILD_EVENTS = values(CREATE_CHILD_CONSTANTS);
var createChildPromise = function createChildPromise(dispatch, createChildModel, accountHierarchyId, parentCustomerId, defaultAddress, subscriberId) {
  return ThunkHelper(dispatch, CREATE_CHILD_EVENTS, {
    data: {
      HierarchyId: accountHierarchyId,
      HierarchySubscriber: subscriberId ? null : buildHierarchySubscriberObject(createChildModel.Customer),
      NodeName: buildHierarchyNodeName(createChildModel.Customer),
      ParentSubscriberId: parentCustomerId,
      SubscriberId: subscriberId
    },
    method: 'post',
    url: 'SubscriberManagement/AddHierarchyNode'
  });
};
export var createChild = function createChild(model, accountHierarchyId, parentCustomerId, defaultAddress, subscriberId) {
  return function (dispatch) {
    return createChildPromise(dispatch, model, accountHierarchyId, parentCustomerId, defaultAddress, subscriberId);
  };
};
export var SET_CREATE_CHILD_MODEL_CONSTANT = 'SET_CREATE_CHILD_MODEL_CONSTANT';
export var setCreateChildModel = function setCreateChildModel(customer) {
  return {
    type: SET_CREATE_CHILD_MODEL_CONSTANT,
    payload: {
      Customer: customer
    }
  };
};
export var buildHierarchySubscriberObject = function buildHierarchySubscriberObject(customer) {
  return pick(['Addresses', 'AutoLogin', 'CountryOverride', 'Credentials', 'PaymentInstruments', 'Subscriber', 'TextScrubberOverride'], buildSubscriberObject(customer));
};
var buildHierarchyNodeName = function buildHierarchyNodeName(customer) {
  if (customer.FirstName || customer.LastName) {
    return customer.FirstName && customer.LastName ? "".concat(customer.FirstName, " ").concat(customer.LastName) : customer.FirstName || customer.LastName;
  } else if (customer.CompanyName) {
    return customer.CompanyName;
  }
};
export var SET_CHILD_FOR_CUSTOMER_HIERARCHY = 'SET_CHILD_FOR_CUSTOMER_HIERARCHY';
export var setChildForCustomerHierarchy = function setChildForCustomerHierarchy(isChildForHeirarchy) {
  return {
    type: SET_CHILD_FOR_CUSTOMER_HIERARCHY,
    payload: isChildForHeirarchy
  };
};
export var REMOVE_HIERARCHY_NODE_CONSTANTS = {
  BEGIN: 'REMOVE_HIERARCHY_NODE_BEGIN',
  SUCCESS: 'REMOVE_HIERARCHY_NODE_SUCCESS',
  FAILURE: 'REMOVE_HIERARCHY_NODE_FAILURE'
};
export var REMOVE_HIERARCHY_NODE_EVENTS = [REMOVE_HIERARCHY_NODE_CONSTANTS.BEGIN, REMOVE_HIERARCHY_NODE_CONSTANTS.SUCCESS, REMOVE_HIERARCHY_NODE_CONSTANTS.FAILURE];
var removeHierarchyNodePromise = function removeHierarchyNodePromise(dispatch, subscriberId) {
  return ThunkHelper(dispatch, REMOVE_HIERARCHY_NODE_EVENTS, {
    method: 'post',
    url: 'SubscriberManagement/RemoveHierarchyNode',
    headers: {
      'CD-SubscriberId': subscriberId
    },
    data: {
      SubscriberId: subscriberId
    }
  });
};
export var removeHierarchyNode = function removeHierarchyNode(subscriberId) {
  return function (dispatch) {
    return removeHierarchyNodePromise(dispatch, subscriberId);
  };
};
export var SET_HIERARCHY_NODE_TO_MOVE = 'SET_HIERARCHY_NODE_TO_MOVE';
export var setHierarchyNodeToMove = function setHierarchyNodeToMove(hierarchyNodeId) {
  return {
    type: SET_HIERARCHY_NODE_TO_MOVE,
    payload: hierarchyNodeId
  };
};
export var SET_TARGET_NODE = 'SET_TARGET_NODE';
export var setHierarchyTargetNode = function setHierarchyTargetNode(hierarchyNodeId) {
  return {
    type: SET_TARGET_NODE,
    payload: hierarchyNodeId
  };
};